import {
  Box,
  Grid,
  alpha,
  Avatar,
  Accordion,
  Typography,
  AvatarGroup,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
} from "@mui/material";

import { ExpandMoreIcon } from "src/Pages/components/Icons/Icons";
import { ListHistoryCampaignLeads } from "./TableHistoryLeads";
import { handleFormatDateToPhraseSignatureWithHour } from "src/shared/Utils/FormatDate/FormatDateToPhraseSignature";
import { colorCampaignFlowsStatus } from "../HelpersObjs/HelpersObjs";
import { CampaignFlowCardDetails } from "./CampaignFlowCardDetails";
import { IDataGetCampaignDetails } from "src/Contexts/Campaign/CampaignContextTypes";

export const CampaignFlowsAccordion = ({
  dataGetCampaignDetails,
}: {
  dataGetCampaignDetails: IDataGetCampaignDetails;
}) => {
  const flows = dataGetCampaignDetails?.flows || [];

  const inProgressId = flows.find((item) => item.status === "IN_PROGRESS")?.id;

  const lastFinishedId = [...flows]
    .reverse()
    .find((item) => item.status === "COMPLETED")?.id;

  const expandedId = inProgressId ?? lastFinishedId;
  return (
    <>
      {dataGetCampaignDetails?.flows?.map((item, index) => {
        return (
          <Accordion
            key={item.title}
            defaultExpanded={item.id === expandedId}
            sx={{
              borderLeft: (theme) =>
                `6px solid ${
                  Math.floor(index % 2) === 0
                    ? alpha(theme.palette.primary.main as string, 0.7)
                    : alpha(theme.palette.primary.main as string, 0.4)
                }`,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                fontSize: { xs: ".8rem", sm: ".9rem", lg: "1rem" },
                display: "inline-flex",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      flexDirection: "column",
                      mr: "16px",
                    }}
                  >
                    <Typography sx={{ fontWeight: "500", mb: "8px" }}>
                      {item.title}
                    </Typography>
                    <Typography>
                      (
                      {handleFormatDateToPhraseSignatureWithHour(item.dateFull)}
                      )
                    </Typography>
                  </Box>

                  <AvatarGroup
                    // renderSurplus={(surplus) => <span>{surplus}</span>}
                    renderSurplus={(surplus) => (
                      <span>+{surplus.toString()[0]}</span>
                    )}
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      "& .MuiAvatar-root": {
                        width: { xs: "30px", sm: "35px" },
                        height: { xs: "30px", sm: "35px" },
                        fontSize: { xs: "1rem", sm: "1rem" },
                      },
                    }}
                    total={
                      dataGetCampaignDetails.groupLeads.GroupManyLeads.length
                      // >
                      // 2
                      //   ? 2
                      //   : dataGetCampaignDetails.groupLeads.GroupManyLeads
                      //       .length
                    }
                  >
                    <Avatar
                      sx={{
                        bgcolor: (theme) => theme.palette.primary.main,
                        fontSize: { xs: "1.2rem", sm: "1.4rem" },
                        width: { xs: "30px", sm: "35px" },
                        height: { xs: "30px", sm: "35px" },
                      }}
                    >
                      {dataGetCampaignDetails.groupLeads.GroupManyLeads[0].leads.name[0].toUpperCase()}
                    </Avatar>
                    {dataGetCampaignDetails.groupLeads.GroupManyLeads[1] && (
                      <Avatar
                        sx={{
                          bgcolor: (theme) => theme.palette.primary.main,
                          fontSize: { xs: "1.2rem", sm: "1.4rem" },
                          width: { xs: "30px", sm: "35px" },
                          height: { xs: "30px", sm: "35px" },
                        }}
                      >
                        {dataGetCampaignDetails.groupLeads.GroupManyLeads[1].leads.name[0].toUpperCase()}
                      </Avatar>
                    )}
                  </AvatarGroup>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {item.status === "IN_PROGRESS" ? (
                    <CircularProgress
                      size={20}
                      sx={{
                        mr: "12px",
                        color: colorCampaignFlowsStatus[item.status].color,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        borderRadius: "50%",
                        backgroundColor:
                          colorCampaignFlowsStatus[item.status].color,
                        width: "10px",
                        height: "10px",
                        marginRight: "12px",
                      }}
                    />
                  )}
                  <Typography sx={{ mr: "8px" }}>
                    {colorCampaignFlowsStatus[item.status].text}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Grid item container xs={12} spacing={2} sx={{ mb: "48px" }}>
                <CampaignFlowCardDetails data={item.CampaignFlowLogs} />
              </Grid>

              <Grid item xs={12}>
                <ListHistoryCampaignLeads data={item} />
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};
